// Footer.jsx
import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/PieDePagina.css';

/*Icons*/
import Tiktok_icon from '../imagenes/icons/tiktok.png';
import Facebook_icon from '../imagenes/icons/facebook.png';
import Youtube_icon from '../imagenes/icons/youtube.png';
import Xtwitter_icon from '../imagenes/icons/x.png';
import Instagram_icon from '../imagenes/icons/instagram.png';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Sección: Información */}
        <div className="footer-section">
          <h3>Municipalidad Provincial de Chumbivilcas</h3>
          <p>Plaza de Armas s/n, Santo Tomás, Cusco - Perú</p>
          <p>Telf: (+51) 964183999</p>
          <p>Horario de atención: 8:00 - 13:00 y 14:30 - 17:30</p>
          <p>Email: contacto@chumbivilcas.gob.pe</p>
        </div>

        {/* Sección: Enlaces útiles */}
        <div className='footer-section'>
          <h4>Enlaces de interés</h4>
          <ul>
            <li><a href='https://www.transparencia.gob.pe/enlaces/pte_transparencia_enlaces.aspx?id_entidad=11810&id_tema=1&ver=D#.XHVxBKC22M8'>Transparencia</a></li>
            <li><a href='https://munichumbivilcas.gob.pe/sgd/tramite_externo.php'>Mesa de Partes Virtual</a></li>
            <Link to='/Convocatorias'>
              <span>Convocatorias CAS</span>
            </Link>
          </ul>
        </div>

        {/* Sección: Redes sociales */}
        <div className="footer-section">
          <h4>Síguenos</h4>
          <div className="social-icons">
            <a href='https://www.tiktok.com/@munichumbivilcas?is_from_webapp=1&sender_device=pc' target='_blank'><img src={Tiktok_icon}/></a>
            <a href='https://web.facebook.com/munichumbivilcas' target='_blank'><img src={Facebook_icon}/></a>
            <a href='https://www.instagram.com/chumbivilcasm/?fbclid=IwY2xjawKGde9leHRuA2FlbQIxMABicmlkETF4M3ZZd2JHbmVnajg0bTBuAR5wed0e_FAsJgKmC2fEuzskZ24xftnAaWf_tBD6bwWiWK6LwEqIFIB4yBn83Q_aem_p0I8lAu8TmXXe6_9vdCWWg#' target='_blank'><img src={Instagram_icon}/></a>
            <a href='https://www.youtube.com/channel/UCDyUske5v7o7TrXe-9Hvvrw' target='_blank'><img src={Youtube_icon}/></a>
            <a href='https://twitter.com/ChumbivilcasM' target='_blank'><img src={Xtwitter_icon}/></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Municipalidad Provincial de Chumbivilcas. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
